import { LitElement, html } from 'lit'
import { customElement, state } from 'lit/decorators.js'

type Route = { name: 'admin' } | { name: 'client', id: string } | { name: 'public', token: string } | { name: 'missing' }

const route = (): Route => {
	const parts = location.pathname.split('/').filter(Boolean)
	if (parts[0] === 'admin' && parts[1] === 'client' && parts[2]) return { name: 'client', id: parts[2] }
	if (parts[0] === 'admin') return { name: 'admin' }
	if (parts[0] === 'c' && parts[1]) return { name: 'public', token: parts[1] }
	return { name: 'missing' }
}

@customElement('invoice-app')
export class InvoiceApp extends LitElement {
	@state() accessor current = route()

	createRenderRoot () {
		return this
	}

	connectedCallback () {
		super.connectedCallback()
		addEventListener('popstate', this.#navigate)
		addEventListener('click', this.#click)
	}

	disconnectedCallback () {
		removeEventListener('popstate', this.#navigate)
		removeEventListener('click', this.#click)
		super.disconnectedCallback()
	}

	#navigate = () => {
		this.current = route()
		scrollTo({ top: 0 })
	}

	#click = (event: MouseEvent) => {
		const anchor = (event.target as Element).closest<HTMLAnchorElement>('a[data-route]')
		if (!anchor || anchor.origin !== location.origin || event.metaKey || event.ctrlKey) return
		event.preventDefault()
		history.pushState(null, '', anchor.href)
		this.#navigate()
	}

	protected render () {
		switch (this.current.name) {
			case 'admin':
				void import('./pages/admin/index.ts')
				return html`<admin-page></admin-page>`
			case 'client':
				void import('./pages/client/index.ts')
				return html`<client-page client-id=${this.current.id}></client-page>`
			case 'public':
				void import('./pages/public/index.ts')
				return html`<public-page token=${this.current.token}></public-page>`
			default:
				return html`<main class='center-page'><section class='empty'><p class='eyebrow'>404</p><h1>Здесь ничего нет</h1><a class='button dark' href='/admin' data-route>В админку</a></section></main>`
		}
	}
}
